module.exports = __webpack_public_path__ + "img/promotion_2.e45f8d48.png";